import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { type Currency, storeCurrency } from '../../generated/client';
import { queryKeys } from '../../query-keys';
import { useClient } from '../queries';

export const useSetClientCurrency = (): UseMutationResult<void, AxiosError, { clientId: number; currency: Currency }> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: async ({ clientId, currency }) => {
            await storeCurrency({ path: { clientId: clientId, currency: currency } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.client(client?.partnerUuid) });
        },
    });
};
